import { useTheme } from "../../../context/theme";
import { Height, ResponsiveProp, Width } from "../../../types";
import { Box, Columns } from "../../layout";
import { MobileNavbarItemProps } from "../MobileNavbarItem/MobileNavbarItem";

type Props = {
  children: React.ReactElement<MobileNavbarItemProps>[];
  height?: ResponsiveProp<Height>;
  width?: ResponsiveProp<Width>;
};

export default function MobileNavbar({
  children,
  width = "100%",
  height = "auto"
}: Props) {
  const theme = useTheme();

  return (
    <Box
      width={width}
      height={height}
      backgroundColor={theme.foreground}
      borderWidth="none"
      borderTopWidth="xxxsmall"
      borderStyle="solid"
      borderColor={theme["neutral-xLow-content"]}
    >
      <Columns>{children}</Columns>
    </Box>
  );
}
